import i18n from '@/i18n';
/** Finance's configured display zone, matching the report history. */
export function configurationDate(value: string): string {
  return new Intl.DateTimeFormat(i18n.resolvedLanguage, {
    timeZone: 'Europe/Rome',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));
}
